import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, BookOpen, Wallet, RefreshCw, Receipt, CheckSquare, FileText, LogOut, PieChart, UserCog, ClipboardList, ShieldCheck, Settings as SettingsIcon } from 'lucide-react';

const Layout = ({ children, user, onLogout }) => {
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/clients', icon: Users, label: 'Clients' },
    { path: '/ledger', icon: BookOpen, label: 'Ledger' },
    { path: '/cash-pool', icon: Wallet, label: 'Cash Pool' },
    { path: '/cycles', icon: RefreshCw, label: 'Cycles' },
    { path: '/expenses', icon: Receipt, label: 'Expenses' },
    { path: '/reports', icon: FileText, label: 'Reports' },
    { path: '/company-pnl', icon: PieChart, label: 'Company P&L' },
  ];

  // Admin-only menu items
  if (user.is_admin) {
    menuItems.push(
      { path: '/approvals', icon: CheckSquare, label: 'Approvals' },
      { path: '/users', icon: UserCog, label: 'User Management' },
      { path: '/audit-logs', icon: ClipboardList, label: 'Audit Logs' },
      { path: '/data-quality', icon: ShieldCheck, label: 'Data Quality' },
      { path: '/settings', icon: SettingsIcon, label: 'Settings' }
    );
  }

  return (
    <div className="flex h-screen" style={{ background: 'var(--cb-paper)' }}>
      {/* Sidebar */}
      <div className="cb-sidebar w-64 flex flex-col">
        {/* Logo mark only — no wordmark */}
        <div className="cb-sidebar-logo">
          <img src="/coinbills-cmark.svg" alt="" data-testid="sidebar-logo" />
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto" style={{ paddingTop: 'var(--cb-space-3)', paddingBottom: 'var(--cb-space-4)' }}>
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
                className={`cb-nav-item ${isActive ? 'cb-nav-item--active' : ''}`}
              >
                <Icon className="w-4 h-4" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* User Section */}
        <div className="cb-sidebar-user">
          <div className="flex items-center justify-between">
            <div>
              <p className="cb-user-name">{user?.name}</p>
              <p className="cb-user-role">{user?.is_admin ? 'Admin' : 'User'}</p>
            </div>
            <button
              onClick={onLogout}
              data-testid="logout-button"
              className="cb-sidebar-logout"
            >
              <LogOut className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 overflow-auto">
          {children}
        </div>
        <footer className="cb-footer" data-testid="app-footer">
          <div className="cb-footer-brand">
            <img src="/coinbills-cmark.svg" alt="" />
            <span>Private Wealth</span>
          </div>
          <span className="cb-footer-timestamp cb-num">
            {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}
          </span>
        </footer>
      </div>
    </div>
  );
};

export default Layout;
